const GUIDE_OPTIONS = [
  {
    id: 'learn',
    label: 'Learning about climate change',
    path: '/learn',
  },
  {
    id: 'risks',
    label: 'Exploring climate risk data',
    path: '/risks',
  },
  {
    id: 'adaptation',
    label: 'Exploring adaptation plans & stories',
    path: '/adaptation',
  },
];

export { GUIDE_OPTIONS };